<template>
  <div class="flex-row">
    <div class="row-item no-text-select" v-if="showDateRangeFilter" v-click-outside="() => closeFilter('date_range')">
      <div @click="toggleDateRangeFilter">
        <img src="../../../assets/images/filterdaterange.svg" class="row-item-icon"/>
        <span class="row-item-txt">
          {{$t('calendar')}}{{dateRangeFilterData.startDate || dateRangeFilterData.endDate ? ':' : ''}} <span class="show-filters"> {{dateRangeFilterData.startDate ? dateRangeFilterData.startDate : ''}}{{dateRangeFilterData.startDate && dateRangeFilterData.endDate ? ' / ' : ''}}{{dateRangeFilterData.endDate ? dateRangeFilterData.endDate : ''}}</span>
          </span>
      </div>
      <DateFilter
          v-if="showDateRangeDropdown"
          :visible.sync="showDateRangeDropdown"
          :on-filter="handleApplyDateFilters"
      />
      <img src="../../../assets/images/cross.svg" @click="() => removeFilter('date_range')" />
    </div>

    <div class="row-item filter" v-click-outside="() => closeFilter('main')" @click="toggleFilter">
      <img src="../../../assets/images/filter.svg">
      <span class="row-item-txt no-text-select">
            {{ $t('filter_program') }}
        </span>
      <FilterModal :visible.sync="showFilter" @filter-selected="handleFilterSelected"/>
    </div>
  </div>
</template>

<script>
import DateFilter from "@/components/table-filters/DateFilter.vue";
import FilterModal from "@/components/tables/Report/ReportsFiltersModal.vue";
import MinMaxNumberFilter from "@/components/table-filters/MinMaxNumberFilter.vue";

export default {
  name: 'ReportsFilters',
  components: {
    MinMaxNumberFilter,
    DateFilter,
    FilterModal
  },

  props: {
    tabType: {
      type: String,
      default: 'test',
      validator: (value) => ['test', 'program', 'user', 'gameLabs'].includes(value)
    }
  },

  watch: {
    '$route.query': {
      handler(newQuery, oldQuery) {
        if (this.$route.query['created_at[start]']) {
          this.currentTabFilters.showDateRangeFilter = true;
          this.currentTabFilters.dateRangeFilterData.startDate = this.$route.query['created_at[start]'];
        } else {
          this.currentTabFilters.dateRangeFilterData.startDate = undefined;
        }

        if (this.$route.query['created_at[end]']) {
          this.currentTabFilters.showDateRangeFilter = true;
          this.currentTabFilters.dateRangeFilterData.endDate = this.$route.query['created_at[end]'];
        } else {
          this.currentTabFilters.dateRangeFilterData.endDate = undefined;
        }
      },
      deep: true,
      immediate: true
    },
  },

  data() {
    return {
      showFilter: false,
      filterStates: {
        test: {
          showDateRangeFilter: false,
          showDateRangeDropdown: false,
          dateRangeFilterData: { startDate: undefined, endDate: undefined }
        },
        program: {
          showDateRangeFilter: false,
          showDateRangeDropdown: false,
          dateRangeFilterData: { startDate: undefined, endDate: undefined }
        },
        user: {
          showDateRangeFilter: false,
          showDateRangeDropdown: false,
          dateRangeFilterData: { startDate: undefined, endDate: undefined }
        },
        gameLabs: {
          showDateRangeFilter: false,
          showDateRangeDropdown: false,
          dateRangeFilterData: { startDate: undefined, endDate: undefined }
        }
      }
    }
  },

  computed: {
    currentTabFilters() {
      return this.filterStates[this.tabType];
    },

    showDateRangeFilter: {
      get() { return this.currentTabFilters.showDateRangeFilter; },
      set(value) { this.currentTabFilters.showDateRangeFilter = value; }
    },

    showDateRangeDropdown: {
      get() { return this.currentTabFilters.showDateRangeDropdown; },
      set(value) { this.currentTabFilters.showDateRangeDropdown = value; }
    },

    dateRangeFilterData: {
      get() { return this.currentTabFilters.dateRangeFilterData; },
      set(value) { this.currentTabFilters.dateRangeFilterData = value; }
    }
  },

  methods: {
    handleFilterSelected(filterName) {
      this.closeFilter('main');
      if (filterName === 'date_range') {
        this.currentTabFilters.showDateRangeFilter = true;
        this.currentTabFilters.showDateRangeDropdown = true;
      }
    },

    formatDateForBackend(dateString) {
      if (!dateString) return undefined;
      const [day, month, year] = dateString.split('-');
      return `${year}-${month}-${day}`;
    },

    handleApplyDateFilters(filters) {
      console.log('🎯 ReportsFilters handleApplyDateFilters called with:', filters);

      this.currentTabFilters.dateRangeFilterData.startDate = filters.startDate;
      this.currentTabFilters.dateRangeFilterData.endDate = filters.endDate;
      this.currentTabFilters.showDateRangeDropdown = false;

      const formattedStartDate = this.formatDateForBackend(filters.startDate);
      const formattedEndDate = this.formatDateForBackend(filters.endDate);

      console.log('📡 Pushing to router with params:', {
        'created_at[start]': formattedStartDate,
        'created_at[end]': formattedEndDate
      });

      this.$router.push({
        query: {
          ...this.$route.query,
          'created_at[start]': formattedStartDate,
          'created_at[end]': formattedEndDate
        }
      });
    },

    toggleFilter() {
      this.showFilter = !this.showFilter;
    },

    toggleDateRangeFilter() {
      this.currentTabFilters.showDateRangeDropdown = !this.currentTabFilters.showDateRangeDropdown;
    },

    closeFilter(filter) {
      if (filter === 'main' && this.showFilter === true) {
        this.showFilter = false;
      }
      if (filter === 'date_range' && this.currentTabFilters.showDateRangeDropdown === true) {
        this.currentTabFilters.showDateRangeDropdown = false;
      }
    },

    removeFilter(filter) {
      if (filter === 'date_range') {
        this.currentTabFilters.showDateRangeFilter = false;
        this.currentTabFilters.dateRangeFilterData = {
          startDate: undefined,
          endDate: undefined,
        };

        const newQuery = { ...this.$route.query };
        delete newQuery['created_at[start]'];
        delete newQuery['created_at[end]'];

        this.$router.push({ query: newQuery });
      }
    },
  }
}
</script>

<style scoped>
.flex-row {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  position: relative;
  gap: 5px;
  align-items: center;
  font-size: 12px;
  color: #344054;
  font-feature-settings: 'clig' off, 'liga' off;
}

.row-item {
  display: flex;
  flex-direction: row;
  gap: 5px;
  align-items: center;
  font-size: 12px;
  color: #344054;
  font-feature-settings: 'clig' off, 'liga' off;
  border-radius: 8px;
  padding: 8px;
  background-color: #f2f2f2;
  position: relative;
  cursor: pointer;
}

.row-item.filter {
  background-color: transparent;
}

.row-item-txt {
  font-size: 12px;
  color: #344054;
  font-feature-settings: 'clig' off, 'liga' off;
  font-weight: 500;
  font-style: normal;
  white-space: nowrap;
}

.show-filters {
  font-family: euclid_medium, sans-serif;
  color: #4A68F8;
  font-feature-settings: 'clig' off, 'liga' off;
  font-size: 12px;
  font-style: normal;
  line-height: 16px;
}
</style>
